var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}monitor`,"viewBox":"0 0 17 14"}},[_c('path',{attrs:{"fill":_vm.getColor('main'),"stroke":"none","d":"M15,0H2C0.9,0,0,0.9,0,2v7c0,1.1,0.9,2,2,2h6v2H4v1h9v-1H9v-2h6c1.1,0,2-0.9,2-2V2C17,0.9,16.1,0,15,0z M16,9c0,0.55-0.45,1-1,1H2c-0.55,0-1-0.45-1-1V2c0-0.55,0.45-1,1-1h13c0.55,0,1,0.45,1,1V9z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }